import { getAllData, getAllDataWithoutToast } from "apis/customApiHandler";
import useDebounce from "hooks/useDebounce";
import React, { useEffect, useState } from "react";
import { QueryClient, useQuery, useQueryClient } from "react-query";
import { Button } from "styled";
import { formatDate } from "utils/helpers";
import RenderProgressBar from "./RenderProgressBar";

export const SyncMaster = ({ socket }) => {
    const [progressState, setProgressState] = useState({})
    const listOfEvents = [
        { code: "sync_hubs", name: "Sync Hubs", api: "customer-hub/sync" },
        { code: "sync_fleets", name: "Sync Fleets", api: "customer-fleet/sync" },
        { code: "sync_territories", name: "Sync Regions", api: "customer-hub/sync/territories" },
        { code: "sync_brands", name: "Sync Brands", api: "product/sync/brands" },
        { code: "sync_products", name: "Sync Materials", api: "product/sync/products" },
        { code: "sync_sizes", name: "Sync Size", api: "product/sync/size" },
        { code: "sync_ndp", name: "Sync NDP", api: "product/sync/NDP" },
        { code: "sync_nsd", name: "Sync NSD", api: "product/sync/NSD" },
        { code: "sync_tube_mapping", name: "Sync Tube Mapping", api: "product/sync/tube-mapping" },
        
        // { code: "sync_grooves", name: "Sync Grooves", api: "product/sync/grooves" },
    ]
    useEffect(() => {
        if (!socket) {
            console.warn("⚠️ Socket is not defined yet!");
            return;
        }

        listOfEvents.forEach(event => {
            console.log("🔍 Subscribing to event:", event.code, socket);
            socket.on(event.code.trim(), (currentValue, maxValue) => {
                console.log("📥 Received Event", event.code, currentValue / maxValue);

                setProgressState(prevState => ({
                    ...prevState,
                    [event.code]: {
                        percent: (currentValue / maxValue) * 100,
                        max: maxValue,
                        val: currentValue
                    }
                }));
            });
        });

        return () => {
            listOfEvents.forEach(event => {
                socket.off(event.code.trim());
            });
        };
    }, [socket]);


    const syncEvent = async (api, eventCode, setLoading) => {
        try { await getAllData(api, { eventCode }); }
        catch (err) {
        } finally {
            console.log("Setting loading to false")
            setLoading(false)
        }
    }

    return (
        <div className="flex flex-col items-center mx-auto gap-4 w-full lg:w-[100%] px-[2%] shadow-sm ">
            {/* <text className="text-lg text-center font-semibold text-gray-600"> Sync Master </text> */}
            <p className="italic text-md text-red-500 mt-3"> *Please note masters automatically sync at 8 AM and 7 PM, one cannot be manually synced more than 3 times a day</p>
            <p className="italic text-md text-red-500 mt-3"> *While syncing, follow the same order as listed below</p>
            <ul className="flex flex-col justify-center items-stretch mx-auto gap-3 w-full">
                {listOfEvents.map(event => {
                    return <li>
                        <RenderProgressBar
                            syncEvent={syncEvent}
                            progressState={progressState[event.code]}
                            setProgressState={setProgressState}
                            event={event} />
                    </li>
                })}
            </ul>

        </div>
    )
}